import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateExternalDashboardsSettingsRequest,
  UpdateField,
  FetchExternalDashboardsSettingsRequest,
} from './external-dashboard-settings.actions'
import { getFormsState } from '../forms/forms.selectors'
import FormTrait from 'src/app/traits/form.trait'
import { getExternalDashboardsSettingsState } from './external-dashboard-settings.selectors'
import { Component, OnDestroy, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { select, Store } from '@ngrx/store'
import { Map } from 'immutable'

@Component({
  selector: 'app-external-dashboard-settings',
  templateUrl: './external-dashboard-settings.component.html',
  styleUrls: ['./external-dashboard-settings.component.css'],
})
export class ExternalDashboardsSettingsComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public forms: []
  private state$: Subscription
  private formsState$: Subscription
  public isLoading: boolean

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.state$ = this.store
      .pipe(select(getExternalDashboardsSettingsState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.formsState$ = this.store
      .pipe(select(getFormsState))
      .subscribe((state) => {
        this.forms = state.get('data').toJS()
      })

    this.store.dispatch(new FetchExternalDashboardsSettingsRequest())
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.formsState$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, name ? e : e.target.value, 'data'),
    )

    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        '',
      ),
    )
  }

  public checkboxChange(e: any, name?: string): void {
    this.store.dispatch(
      new UpdateField(name || e.target.name, e.target.checked, 'data'),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      SETTINGS_EXTERNAL_DASHBOARDS_URL: 'required',
    }
    const validator = new Validator(data.toJS(), rules)

    validator.setAttributeNames({
      SETTINGS_EXTERNAL_DASHBOARDS_URL: 'external dashboards URL',
    })

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new UpdateExternalDashboardsSettingsRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField('validationErrors', validation.errors.errors, ''),
      )
    }
  }
}
